export default {"src":"/_next/static/media/animation_640_lj8fw28l.81e77725.gif","height":640,"width":640,"blurWidth":0,"blurHeight":0};